import { totalBrackets } from '../constants'
import '../css/SemanticNode.scss'
import { toHex } from '../scripts/utils'
import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'

export default class SemanticNode extends PureComponent {
  render() {
    const {
      count,
      text,
      mark,
      color,
      pseudoExpandSelectionResults,
      inPseudo,
      inPseudoAndLastOfPseudo,
      mode,
    } = this.props

    const nodeStyle = {
      zIndex: inPseudo ? -9 : undefined,
    }
    let nodeExtraClass = ''

    const getOpacity = speed => {
      switch (speed) {
        case 3:
          return 'bb'
        case 2:
          return '55'
        case 1:
          return '22'
        default:
          break
      }
    }
    if (pseudoExpandSelectionResults) {
      for (let side in pseudoExpandSelectionResults) {
        if (pseudoExpandSelectionResults[side].length) {
          for (let expect in pseudoExpandSelectionResults[side]) {
            const thisExpect = pseudoExpandSelectionResults[side][expect]
            if (thisExpect.count === count) {
              if (side === 'after')
                nodeExtraClass = ' pseudo-node-after pseudo-node'
              else nodeExtraClass = ' pseudo-node-before pseudo-node'

              if ((inPseudoAndLastOfPseudo || !inPseudo) && mode === 'touch') {
                nodeStyle.boxShadow = `0 0 0 2px #fff, 0 0 0 2px #fff, 0 0 0 2px #fff, ${
                  side === 'after' ? '3px' : '-3px'
                } 0 0 2px #${toHex(...color)}${getOpacity(
                  thisExpect.expectedSpeed
                )}`
              }

              if (mode === 'touch')
                nodeStyle.zIndex = `${
                  -99 * (1 + totalBrackets - thisExpect.expectedSpeed)
                }`
            }
          }
        }
      }
    }

    return (
      <div
        className={
          'node' +
          (mark ? ' mark-node' : ' text-node') +
          (text[1] ? ' space-after' : '') +
          nodeExtraClass
        }
        style={nodeStyle}
        data-count={count}
      >
        {text[0]}
      </div>
    )
  }
}

SemanticNode.propTypes = {
  text: PropTypes.array,
  count: PropTypes.number,
  mark: PropTypes.bool,
  color: PropTypes.array,
  pseudoExpandSelectionResults: PropTypes.object,
  inPseudo: PropTypes.bool,
  inPseudoAndLastOfPseudo: PropTypes.bool,
  mode: PropTypes.string,
}
